import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../subscriptions.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

const tableHeaderColumnData = [
    {
      dataField: 'animal_type', text: 'Animal Type', sort: false 
    },
    {
      dataField: 'breed_type', text: 'Breed Type', sort: false 
    },
    {
      dataField: 'date_of_create', text: 'Date of Create', sort: false
    },
    {
        dataField: 'actions', text: 'Actions', sort: false, formatter:(cell,row)=>{
          return (
              <span>
                  <button className="btn m-btn--pill  btn-success btn-sm px-3 py-1 mx-2 my-2">View Details</button>
                  {cell}
              </span>
          )
    }
    }
  ];
const contentData= [{animal_type:'45435', breed_type:'lkdddf',date_of_create:'sfdsfsd'}];

class BreedsList extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (
    <div className="m-grid m-grid--hor m-grid--root m-page" style={{ minHeight: '100vh'}}>
        <body className="m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--fixed m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default">
            <div className="m-grid m-grid--hor m-grid--root m-page">
                <header id="m_header" className="m-grid__item    m-header " m-minimize-offset="200" m-minimize-mobile-offset="200">
                    <div className="m-container m-container--fluid m-container--full-height">
                        <div className="m-stack m-stack--ver m-stack--desktop">
                            <div className="m-stack__item m-brand  m-brand--skin-dark ">
                                <div className="m-stack m-stack--ver m-stack--general">
                                    <div className="m-stack__item m-stack__item--middle m-brand__logo">
                                        <a href="index.html" className="m-brand__logo-wrapper">
                                            <img alt="" src="../../../assets/app/media/img/petpos-white.png" style={{width:'80px'}}/>
                                        </a>
                                    </div>
                                    <div className="m-stack__item m-stack__item--middle m-brand__tools">
                                        <a href="" id="m_aside_left_minimize_toggle" className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block">
                                            <span></span>
                                        </a>
                                        <a href="" id="m_aside_left_offcanvas_toggle" className="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
                                            <span></span>
                                        </a>
                                        <a id="m_aside_header_menu_mobile_toggle" href="" className="m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
                                            <span></span>
                                        </a>
                                        <a id="m_aside_header_topbar_mobile_toggle" href="" className="m-brand__icon m--visible-tablet-and-mobile-inline-block">
                                            <i className="flaticon-more"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
                    <button className="m-aside-left-close  m-aside-left-close--skin-dark " id="m_aside_left_close_btn">
                        <i className="la la-close"></i>
                    </button>
                    <div id="m_aside_left" className="m-grid__item	m-aside-left  m-aside-left--skin-dark ">
                        <div id="m_ver_menu" className="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark " m-menu-vertical="1" m-menu-scrollable="1" m-menu-dropdown-timeout="500" style={{position: 'relative'}}>
                            <ul className="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
                                <li className="m-menu__item  m-menu__item--active" aria-haspopup="true">
                                    <a href="index.html" className="m-menu__link ">
                                        <i className="m-menu__link-icon flaticon-line-graph"></i>
                                        <span className="m-menu__link-title">
                                            <span className="m-menu__link-wrap">
                                                <span className="m-menu__link-text">Dashboard</span>
                                                <span className="m-menu__link-badge">
                                                    <span className="m-badge m-badge--danger">2</span>
                                                </span>
                                            </span>
                                        </span>
                                    </a>
                                </li>
                                <li className="m-menu__section ">
                                    <h4 className="m-menu__section-text">Components</h4>
                                    <i className="m-menu__section-icon flaticon-more-v3"></i>
                                </li>
                                <li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
                                    <a href="" className="m-menu__link m-menu__toggle">
                                        <i className="m-menu__link-icon flaticon-paper-plane"></i>
                                        <span className="m-menu__link-text">Subscriptions</span>
                                        <i className="m-menu__ver-arrow la la-angle-right"></i>
                                    </a>
                                </li>
                                <li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
                                    <a href="" className="m-menu__link m-menu__toggle">
                                        <i className="m-menu__link-icon flaticon-users"></i>
                                        <span className="m-menu__link-text">Users</span>
                                        <i className="m-menu__ver-arrow la la-angle-right"></i>
                                    </a>
                                </li>
                                <li className="m-menu__item  m-menu__item--submenu" aria-haspopup="true" m-menu-submenu-toggle="hover">
                                    <a href="" className="m-menu__link m-menu__toggle">
                                        <i className="m-menu__link-icon flaticon-graph"></i>
                                        <span className="m-menu__link-text">Sales</span>
                                        <i className="m-menu__ver-arrow la la-angle-right"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="m-grid__item m-grid__item--fluid m-wrapper">
                        <div className="m-subheader ">
                            <div className="d-flex align-items-center">
                                <div className="mr-auto">
                                    <h3 className="m-subheader__title ">Breeds List</h3>
                                </div>
                            </div>
                        </div>
                        <div className="m-content">
                            <div className="row">
                                <div className="col-xl-12" id="subs">
                                    <BootstrapTable
                                    keyField="id"
                                    data={contentData}
                                    columns={tableHeaderColumnData}
                                    classes="petTable"
                                    defaultSortDirection="asc" 
                                    hover={true} 
                                    // pagination={ paginationFactory() } 
                                    // filter={ filterFactory() }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </body>
    </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});

export default withRouter(connect(mapStateToProps)(BreedsList));